import React, { useEffect, useMemo, useRef, useState } from "react";
import { NotificationManager } from "src/util/notify";
import { Input, MaskedTextBox } from "@progress/kendo-react-inputs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import { SmsService } from "src/services/smsService";
import { Loader } from "@progress/kendo-react-indicators";
import DatePickerKendoRct from "src/control-components/date-picker/date-picker";
import DropDownKendoRct from "src/control-components/drop-down/drop-down";
import { useDispatch, useSelector } from "react-redux";
import { GET_ALL_CLINIC, SMS_LOOKUP_FILTER } from "src/actions";
import apiHelper from "src/helper/api-helper";
import API_URLS from "src/helper/api-urls";
import { MaskFormatted } from "src/helper/mask-helper";
import { getter } from "@progress/kendo-react-common";
import { orderBy } from "@progress/kendo-data-query";
import ReadBAAModal from "src/app-modules/announcement/baaReadBody";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const normalizePhoneNumber = (value) => {
  if (!value) return "";
  const digits = value.replace(/\D/g, "");
  if (digits.length === 10) return `${digits}`;
  return digits;
};

const formatDirection = (direction) => {
  if (!direction) return "Unknown";
  const d = direction.toString().toLowerCase();
  if (d.includes("inbound")) return "Inbound";
  if (d.includes("outbound")) return "Outbound";
  return direction;
};

const formatStatus = (status) => {
  if (!status) return "Unknown";
  return status.toString().charAt(0).toUpperCase() + status.toString().slice(1);;
};

const SmsTwilioLookup = ({ }) => {
  const [loading, setLoading] = useState(false);
  const [lookupResult, setLookupResult] = useState(null);
  const [allClinic, setAllClinic] = useState([]);
  const [allStatus,] = useState([{
    status: "Failed",
    value: "failed"
  },
  {
    status: "Ready To Send",
    value: "Ready To Send"
  },
  {
    status: "Delivered",
    value: "delivered"
  },
  {
    status: "Sent",
    value: "Sent"
  },
  {
    status: "Received",
    value: "Received"
  },
  {
    status: "Undelivered",
    value: "undelivered"
  },
  ]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = useState([]);
  const [selectedState, setSelectedState] = React.useState({});
  const smsLookupFilter = useSelector((state) => state?.smsLookupFilter);
  const hasAutoSearched = useRef(false);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedMsgBody, setShowMsgBody] = useState(false);
  const [searchButtonPressed, setSearchButtonPressed] = useState(false);
  const dispatch = useDispatch();
  const [fields, setFields] = useState({
    clinicId: "",
    dateStart: moment().subtract(3, "days").startOf("day").toDate(), // ✅ FIX
    dateEnd: moment().endOf("day").toDate(), // ✅ FIX
    phone: '',
    status: ''
  });
  useEffect(() => {
    if (smsLookupFilter && !hasAutoSearched.current) {
      const newAdvSearchFields = {
        clinicId: smsLookupFilter.clinicId ?? '',
        dateStart: smsLookupFilter.dateStart ? moment(smsLookupFilter.dateStart) : null,
        dateEnd: smsLookupFilter.dateEnd ? moment(smsLookupFilter.dateEnd) : null,
        phone: maskedValue ?? '',
        status: smsLookupFilter?.status
      }
      setFields(newAdvSearchFields);
    }
  }, [smsLookupFilter]);
  const handleClear = () => {
    dispatch({
      type: SMS_LOOKUP_FILTER,
      payload: {
        clinicId: null,
        dateStart: moment().subtract(3, "days").startOf("day").toDate(), // ✅ FIX
        dateEnd: moment().endOf("day").toDate(), // ✅ FIX
        phone: null,
        status: null
      },
    });
    setMaskedValue(MaskFormatted(null, mask))
    const newAdvSearchFields = {
      clinicId: null,
      dateStart: moment().subtract(3, "days").startOf("day").toDate(), // ✅ FIX
      dateEnd: moment().endOf("day").toDate(), // ✅ FIX
      phone: null,
      status: null
    }
    setFields(newAdvSearchFields
    )
    setLookupResult(null);
  };
  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
  };
  const [errors, setErrors] = useState({});
  useEffect(() => {
    getAllClinic();
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "phone") {
      setMaskedValue(value);
    }
  };

  const validate = () => {
    let newErrors = {};

    if (fields.dateStart && fields.dateEnd) {
      if (moment(fields.dateEnd).isBefore(fields.dateStart)) {
        newErrors.dateEndLessThanStart = "End date must be after start date.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const getAllClinic = async () => {
    setLoading(true);
    apiHelper.getRequest(API_URLS.ALL_CLINIC)
      .then((result) => {
        dispatch({
          type: GET_ALL_CLINIC,
          payload: result.resultData,
        });
        setLoading(false);
        let staffAuditActions = result.resultData;
        setAllClinic(staffAuditActions);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };
  const handleSearch = async (newAdvSearchFields, isClear) => {
    dispatch({
      type: SMS_LOOKUP_FILTER,
      payload: newAdvSearchFields
    });
    setSearchButtonPressed(true)
    hasAutoSearched.current = true;
    let normalized = ''
    if (newAdvSearchFields && newAdvSearchFields.phone) {
      normalized = normalizePhoneNumber(newAdvSearchFields.phone);
    }
    if ((!newAdvSearchFields.clinicId || !newAdvSearchFields.dateStart || !newAdvSearchFields.dateEnd
    ) && !isClear
    ) {
      NotificationManager.error("Please enter all fields before proceeding");
      return;
    }

    if (!validate()) return;

    setLoading(true);
    setLookupResult(null);
    try {
      const payload = {
        masterClinicId: newAdvSearchFields.clinicId?.id,
        startDate: moment(newAdvSearchFields.dateStart).startOf('day').format('MM/DD/YYYY'),
        endDate: moment(newAdvSearchFields.dateEnd).startOf('day').format('MM/DD/YYYY'),
        regionId: newAdvSearchFields?.clinicId?.regionId
      };
      if (newAdvSearchFields && newAdvSearchFields.status && newAdvSearchFields.status.value) {
        payload.status = newAdvSearchFields.status ? newAdvSearchFields.status.value : ''
      }
      if (newAdvSearchFields && newAdvSearchFields.phone && normalized) {
        payload.phoneNumber = normalized
      }
      const response = await SmsService.getTwilioLookup(payload);

      const data = response?.resultData ?? response;
      setLookupResult(data || {});
      setSearchButtonPressed(false);
    } catch (error) {
      NotificationManager.error(
        error?.message || "Unable to fetch SMS history."
      );
    } finally {
      setLoading(false);
    }
  };

  const messageHistory = useMemo(() => {
    if (!lookupResult || (lookupResult === null)) return [];
    const messages =
      lookupResult.messages ?? lookupResult.messageHistory ?? [];
    return Array.isArray(messages) ? messages : [];
  }, [lookupResult]);


  let mask = "(999) 000-0000";
  const rawPhone = (smsLookupFilter.phone || fields.phone || "").replace(/\D/g, "");
  const [maskedValue, setMaskedValue] = useState(MaskFormatted(rawPhone, mask));

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "-";
    const digits = value.replace(/\D/g, "");
    const last10 = digits.slice(-10);
    if (last10.length !== 10) return value;
    return `(${last10.slice(0, 3)}) ${last10.slice(3, 6)}-${last10.slice(6)}`;
  };

  return (
    <>
      <h4 className="address-title text-grey mb-3">
        <span className="f-24">SMS / Twilio Lookup</span>
      </h4>

      {/* ROW 1 */}
      <div className="row align-items-end mb-3">
        <div className="col-lg-2 col-md-2 col-12 mb-2 edit-Service-popup sms-twilio-lookup position-relative">
          <DropDownKendoRct
            label="Master Clinic Name"
            onChange={handleChange}
            error={(!fields.clinicId && searchButtonPressed) && 'Master Clinic is required'}
            data={allClinic}
            value={fields.clinicId}
            textField="clinicName"
            name="clinicId"
          />
        </div>

        <div className="col-lg-2 col-md-2 col-12 mb-2 date-field edit-Service-popup">
          <label className="form-label mb-3" style={{ fontSize: "0.875rem" }}>
            Start Date
          </label>
          <DatePickerKendoRct
            value={new Date(fields.dateStart)}
            name="dateStart"
            error={(!fields.dateStart && searchButtonPressed) && 'Start Date is required'}

            onChange={handleChange}
          />
        </div>
        <div className="col-lg-2 col-md-2 col-12 mb-2 date-field edit-Service-popup">
          <label className="form-label mb-3" style={{ fontSize: "0.875rem" }}>
            End Date
          </label>
          <DatePickerKendoRct
            value={new Date(fields.dateEnd)}
            onChange={handleChange}
            name="dateEnd"
            error={(!fields.dateEnd && searchButtonPressed) && 'End Date is required'}

          />
          {errors.dateEndLessThanStart && (
            <div className="text-danger">{errors.dateEndLessThanStart}</div>
          )}
        </div>
        <div className="col-lg-2 col-md-2 col-12 mb-2 edit-Service-popup">
          <label className="form-label" style={{ fontSize: "0.875rem" }}>
            Status
          </label>
          <DropDownKendoRct
            onChange={handleChange}
            data={allStatus}
            value={fields.status}
            textField="status"
            name="status"
          />
        </div>

        {/* ROW 2 */}
        <div className="col-lg-2 col-md-2 col-12 mb-2">
          <label className="form-label" style={{ fontSize: "0.875rem" }}>
            Client Phone Number
          </label>
          <MaskedTextBox
            width="100%"
            mask={mask}
            name={'phone'}
            value={maskedValue || ''}

            onChange={handleChange}
            onKeyPress={handleKeyDown}
          />
        </div>
        <div className="col-lg-2 col-md-2 col-12 mb-2">
          <div className="btn-align-cus d-flex justify-content-start ">
            <button className="green-btn btn-primary" onClick={() => handleSearch(fields, false)}>
              Filter
            </button>
            <button
              className="btn text-grey ml-3"
              onClick={handleClear}
            >
              Clear
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="row mb-4">

          </div>

          <div className="grid-table filter-grid">
            <div className="inner-section-edit position-relative">
              <Grid
                data={orderBy(messageHistory?.slice(page, pageSize + page), sort).map(
                  (item) => ({
                    ...item,
                    [SELECTED_FIELD]: selectedState[idGetter(item)],
                  })
                )}
                checkboxElement
                style={{
                  height: messageHistory.length > 0 ? "100%" : "250px",
                }}
                dataItemKey={DATA_ITEM_KEY}
                selectedField={SELECTED_FIELD}
                skip={page}
                take={pageSize}
                total={messageHistory.length}
                onPageChange={pageChange}
                className="pagination-row-cus"
                pageable={{
                  pageSizes: [10, 20, 30],
                }}
                sort={sort}
                sortable={true}
                onSortChange={(e) => {
                  setSort(e.sort);
                }}
                scrollable="none"
              >
                <GridColumn
                  field="messageTimestamp"
                  title="Time Stamp"
                  width="200px"
                  cells={{
                    data: (props) => {
                      const value =
                        props.dataItem.messageTimestamp

                      const formatted = value
                        ? moment(value)
                          .local()
                          .format("M/D/YYYY h:mm A")
                        : "-";

                      return <td>{formatted}</td>;
                    },
                  }}
                />
                <GridColumn
                  field="clientName"
                  title="Client"
                  width="200px"
                  cells={{
                    data: (props) => {
                      const value =
                        props.dataItem.clientName

                      return <td>{value}</td>;
                    },
                  }}
                />
                <GridColumn
                  field="fromPhoneNumber"
                  title="From Phone Number (Clinic)"
                  width="240px"
                  cells={{
                    data: (props) => (
                      <td style={{ whiteSpace: "pre-wrap" }}>
                        {formatPhoneNumber(props.dataItem.fromPhoneNumber) ??
                          "-"}
                      </td>
                    ),
                  }}
                />
                <GridColumn
                  field="toPhoneNumber"
                  title="To Phone Number (Client)"
                  width="240px"
                  cells={{
                    data: (props) => (
                      <td style={{ whiteSpace: "pre-wrap" }}>
                        {formatPhoneNumber(props.dataItem.toPhoneNumber) ??
                          "-"}
                      </td>
                    ),
                  }}
                />
                <GridColumn
                  field="direction"
                  title="Direction"
                  width="130px"
                  cells={{
                    data: (props) => (
                      <td>
                        {formatDirection(
                          props.dataItem.direction
                        )}
                      </td>
                    ),
                  }}
                />

                <GridColumn
                  field="deliveryStatus"
                  title="Delivery Status"
                  width="140px"
                  cells={{
                    data: (props) => (
                      <td>
                        {formatStatus(props.dataItem.deliveryStatus)}
                      </td>
                    ),
                  }}
                />

                <GridColumn
                  field="errorCode"
                  title="Error Reason"
                  width="120px"
                  cells={{
                    data: (props) => (
                      <td>
                        {props.dataItem.errorReason ??
                          "-"}
                      </td>
                    ),
                  }}
                />
                <GridColumn
                  field="isOptedOut"
                  title="Is Opted Out?"
                  width="120px"
                  cells={{
                    data: (props) => {
                      return (
                        <td>
                          {((props.dataItem.isOptedOut) && (!props.dataItem.canSendTextSMS)) ? (
                            <span>Yes</span>
                          ) : (
                            <span>No</span>
                          )}
                        </td>
                      );
                    },
                  }}
                />
                <GridColumn
                  field="body"
                  title="Action"
                  width="160px"
                  cells={{
                    data: (props) => {
                      const message = props.dataItem.message || "";

                      return (
                        <td>
                          {message ? (
                            <button
                              className="btn btn-link p-0"
                              onClick={() => {
                                setShowDialog(true);
                                setShowMsgBody(message);
                              }}
                            >
                              View
                            </button>
                          ) : (
                            "-"
                          )}
                        </td>
                      );
                    },
                  }}
                />
              </Grid>
              {
                showDialog && (
                  <ReadBAAModal
                    title={'Read Message'}
                    onClose={() => setShowDialog(false)}
                    message={selectedMsgBody}
                  />
                )
              }
            </div>
          </div>
        </>

      )}
    </>
  );
};

export default SmsTwilioLookup;